/**
 * Portal diagnostics — the point of the Report-a-problem feature, not the text
 * box. Keeps small ring buffers of the last few API calls (method/url/status)
 * and client-side errors, and stamps route + user agent at report time. User
 * agent alone would have diagnosed the iOS download bug in one read.
 */
const MAX = 12;
const apiBuf = [];
const errBuf = [];

export function recordApiCall(method, url, status) {
  apiBuf.push({
    t: new Date().toISOString(),
    method: (method || '').toUpperCase(),
    url: url || '',
    status: status == null ? 'no-response' : status,
  });
  if (apiBuf.length > MAX) apiBuf.shift();
}

function recordError(message, extra) {
  errBuf.push({ t: new Date().toISOString(), message: String(message).slice(0, 400), ...extra });
  if (errBuf.length > MAX) errBuf.shift();
}

let registered = false;
export function registerErrorCapture() {
  if (registered || typeof window === 'undefined') return;
  registered = true;
  window.addEventListener('error', (e) => {
    recordError(e.message || 'error',
      e.filename ? { src: `${e.filename}:${e.lineno || 0}` } : {});
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    recordError((r && (r.message || r)) || 'unhandledrejection', { kind: 'promise' });
  });
}

export function getDiagnostics() {
  const loc = (typeof window !== 'undefined' && window.location) || {};
  return {
    route: (loc.pathname || '') + (loc.hash || ''),
    user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    timestamp: new Date().toISOString(),
    viewport: typeof window !== 'undefined'
      ? { w: window.innerWidth, h: window.innerHeight } : null,
    recent_api_calls: apiBuf.slice(),
    recent_errors: errBuf.slice(),
  };
}
